import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import cn from 'classnames';

import PromotionBlocks from './PromotionBlocks';
import LinkBack from '../widgets/LinkBack';
import BlockFiles from '../widgets/Typography/BlockFiles';
import BlockPrograms from '../widgets/Typography/BlockPrograms';
import Typography from '../widgets/Typography/Typography';

import './promotion.scss';

class PromotionTemplate extends PureComponent {
  render() {
    return (
      <div className={cn('promotion', this.props.name)}>
        {(this.props.page.meta) &&
          <Helmet>
            <title>{this.props.page.meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="promotion-content">
            <LinkBack link="/promotion/subnavigation/">
              Продвигаем <i>вернуться</i>
            </LinkBack>

            <Typography content={this.props.page.content} />

            <BlockPrograms content={this.props.page.examples} />
          </div>

          <div className="promotion-panel">
            {(!!this.props.page.blocks) &&
              <PromotionBlocks content={this.props.page.blocks}/>
            }

            {(!!this.props.page.files) &&
              <BlockFiles content={this.props.page.files} />
            }
          </div>
        </div>
      </div>
    );
  }
}

PromotionTemplate.propTypes = {
  name: PropTypes.string,
  page: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object),
    examples: PropTypes.arrayOf(PropTypes.object),
    blocks: PropTypes.arrayOf(PropTypes.object),
    files: PropTypes.object,
    meta: PropTypes.shape({
      title: PropTypes.string
    })
  })
};

export default PromotionTemplate;



// WEBPACK FOOTER //
// ./src/components/Promotion/PromotionTemplate.js